<ng-container *transloco="let t">
  <div class="mx-auto flex w-full max-w-screen-2xl flex-col gap-4 pt-10">
    <div>
      <div class="text-2xl font-semibold tracking-tight text-gray-800">{{ t("page-title.user_management") }}</div>
      <div class="text-sm font-medium text-gray-500">{{ t("user-management.page_description") }}</div>
    </div>

    <ITabs [tabs]="tabs" [(activeTab)]="selectedTab" />

    @if (selectedTab() === UserManagementTab.USERS) {
      <div class="flex items-center justify-between">
        <IMultiSelectMenu [(value)]="selectedOrganizations" [(searchQuery)]="searchQuery" popoverWidth="350">
          <ISelectTrigger>
            <ISelectValue>
              <div *iSelectValue="let value">
                {{ value[0]?.organizationName + (value.length > 1 ? " (+" + (value.length - 1) + ")" : "") }}
              </div>
            </ISelectValue>
          </ISelectTrigger>
          <ISelectContent>
            @if (filteredOrganizations() && filteredOrganizations()!.length > 0) {
              <ISelectOption [selectAllOption]="true" />
              <IDropdownMenuSeparator />
            }
            @for (org of filteredOrganizations(); track org.id) {
              <ISelectOption [value]="org">
                {{ org.organizationName }}
              </ISelectOption>
            }
          </ISelectContent>
        </IMultiSelectMenu>
        <div class="flex items-center justify-end gap-2">
          <button iButton [iDropdownMenuTrigger]="addUserMenu" placement="bottom-end">
            <IIcon name="userPlus" />
            {{ t("user-management.add_user") }}
          </button>

          <ng-template #addUserMenu>
            <IDropdownMenu>
              <button iDropdownMenuItem (click)="openAddNewAuthorizedUserModal()">
                {{ t("user-management.add_authorized_users") }}
              </button>
              <button iDropdownMenuItem (click)="openAddAdminModal()">
                {{ t("user-management.add_admins") }}
              </button>
            </IDropdownMenu>
          </ng-template>
        </div>
      </div>

      <div class="ag-theme-quartz w-full flex-1">
        <ag-grid-angular style="width: 100%; height: 75vh" [gridOptions]="gridOptions" [rowData]="gridData()" />
      </div>
    }

    @if (selectedTab() === UserManagementTab.ACTIVITIES) {
      <app-user-activities-grid class="flex-1"></app-user-activities-grid>
    }
  </div>
</ng-container>
